import { CxEvent } from '@spartacus/core';

export class Ga4GgNavigationSelectEvent extends CxEvent {
  event?: string;
  click_url?: string;
  click_name?: string;
  visitor_type?: string;
}
